import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LayoutModule } from '../../layout/layout.module';
import { MensajesComponent } from './mensajes/mensajes.component';
import { NotificacionesComponent } from './notificaciones/notificaciones.component';
import { PedidosRoutingModule } from './pedidos-routing.module';
import { RastreoComponent } from './rastreo/rastreo.component';
import { EnviaComponent } from './tracking/envia/envia.component';
import { ServientregaComponent } from './tracking/servientrega/servientrega.component';


@NgModule({
  declarations: [RastreoComponent, MensajesComponent, EnviaComponent, ServientregaComponent, NotificacionesComponent],
  imports: [
    CommonModule,
    PedidosRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    LayoutModule,
    MatListModule,
  ],
  exports: [RastreoComponent],
})
export class PedidosModule { }
